<template>
  <div id="cup_teamDetail" v-show="currThemeObj">
    <div class="abs_top">
      <div
        class="player_image"
        :class="playerBaseInfor.playerLogo ? 'isLogo' : ''"
      >
        <img :src="playerBaseInfor.playerLogo" />
      </div>
      <div class="player_baseInfor">
        <div class="player_name" v-text="playerBaseInfor.playerName"></div>
        <div class="team_infor">
          <span class="teamLogo">
            <img :src="playerBaseInfor.teamLogo" />
          </span>
          <span class="teamName" v-text="playerBaseInfor.teamName"></span>
        </div>
        <div class="player_info" v-if="playerBaseInfor.age || playerBaseInfor.clubName || playerBaseInfor.height">
          <div>{{ playerBaseInfor.age }}岁</div>
          <div>{{ playerBaseInfor.height }}CM</div>
          <div>{{ playerBaseInfor.clubName }}</div>
        </div>
      </div>
    </div>
    <div class="playerDetail_main" v-if="!isNotDataFlag">
      <div class="left_area">
        <div class="matchData" v-if="thisSeason">
          <span class="item_title">
            <span class="itemTitle_main" v-text="thisSeason.title"></span>
            <span class="itemTitle_desRow">
              <span
                class="row_no"
                v-text="
                  thisSeason.shirtNumber ? `${thisSeason.shirtNumber}号` : ''
                "
              ></span>
              <span class="row_pos" v-text="thisSeason.position"></span>
              <span class="row_act">
                <span v-text="thisSeason.active"></span>
              </span>
            </span>
          </span>
          <span
            class="item_row"
            v-for="item in thisSeason.arr"
            :key="item.colKey"
          >
            <span class="row_name" v-text="item.colTitle"></span>
            <span class="row_val" v-text="item.val"></span>
          </span>
        </div>
        <div class="matchData" v-if="thisCmp">
          <span class="item_title">
            <span class="itemTitle_main" v-text="thisCmp.title"></span>
          </span>
          <span class="item_row" v-for="item in thisCmp.arr" :key="item.colKey">
            <span class="row_name" v-text="item.colTitle"></span>
            <span class="row_val" v-text="item.val"></span>
          </span>
        </div>
      </div>
      <div class="right_area" v-if="statArr">
        <div class="group_data" v-for="group in statArr" :key="group.key">
          <span class="groupData_title" v-text="group.title"></span>
          <div
            class="groupData_row"
            v-for="(row, rowIndex) in group.arr"
            :key="rowIndex"
          >
            <cup_svgCircle
              v-if="row.left"
              :currThemeObj="currThemeObj"
              :cx="cx"
              :cy="cy"
              :strokeWidth="strokeWidth"
              :svgDataArr="row.left"
              :keyArr="cup_svgCircle_keyArr"
              :totalName="row.totalName"
            ></cup_svgCircle>
            <div class="itemOther_targetList">
              <span
                class="targetList_item"
                v-for="(right, rightIndex) in row.right"
                :key="rightIndex"
              >
                <span
                  class="targetItem_val"
                  v-text="right.value ? right.value : '-'"
                ></span>
                <span class="targetItem_tip" v-text="right.name"></span>
              </span>
              <!-- <span class="targetList_item">
            <span class="targetItem_val">30</span>
            <span class="targetItem_tip">asdadadasda</span>
          </span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <cup_notData className="relativePtb30" v-if="isNotDataFlag"></cup_notData>
  </div>
</template>

<script>
import { https_cup_playerDetail } from '@api/platfrom_football_api'
import cup_svgCircle from '@components/platfromBase/football/cup_svgCircle.vue'
import cup_notData from '@components/base/NO_DATA.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'cup_teamDetail',
  components: { cup_svgCircle, cup_notData },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      playerBaseInfor: {
        playerName: '',
        playerLogo: '',
        playerId: '',
        teamName: '',
        teamLogo: '',
        teamId: '',
      },
      thisSeason: null,
      thisCmp: null,
      // svgDataArr: null,
      strokeWidth: 4,
      cxVw: 4.65,
      cyVw: 4.65,
      bodyWidth: 0,
      statArr: null,
      cup_svgCircle_keyArr: ['name', 'value'],
      isNotDataFlag: false,
    }
  },
  created() {
    this.bodyWidth = window.innerWidth
      ? window.innerWidth
      : window.screen.width
      ? window.screen.width
      : 375
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    const query = this.$route.query
    this.init(query)
    // window.setTimeout(() => {
    //   this.svgDataArr = [
    //     {
    //       val: 0,
    //       name: '11',
    //       key: 1,
    //     },
    //     {
    //       val: '',
    //       name: '22',
    //       key: 2,
    //     },
    //     {
    //       val: 10,
    //       name: '22',
    //       key: 3,
    //     },
    //   ]
    // }, 10)
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    cx() {
      return Math.ceil((this.bodyWidth / 100) * this.cxVw)
    },
    cy() {
      return Math.ceil((this.bodyWidth / 100) * this.cyVw)
    },
  },
  methods: {
    async init(params) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getPlayerDetail(params)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    onResizeEvent() {
      this.bodyWidth = document.body.clientWidth
    },
    async getPlayerDetail(params) {
      await https_cup_playerDetail(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const baseInfo = res.data.baseInfo
            if (baseInfo) {
              this.playerBaseInfor = baseInfo
            }
            const statArr = [
              {
                key: 'keyStat',
                title: '关键数据',
                arr: [],
              },
              {
                key: 'ofsStat',
                title: '进攻数据',
                arr: [],
              },
              {
                key: 'dfsStat',
                title: '防守数据',
                arr: [],
              },
              {
                key: 'orgStat',
                title: '组织数据',
                arr: [],
              },
            ]
            let isNotDataFlag = true
            this.statArr = statArr.map((item) => {
              const itemData = res.data[item.key]
              console.debug('itemData:', itemData)
              if (itemData && itemData.length > 0) {
                // 如果某个有值则有数据
                isNotDataFlag = false
              }
              item.arr = itemData ? itemData : []
              return item
            })
            this.isNotDataFlag = isNotDataFlag
            const thisSeasonExpKey = [
              'competitionId',
              'seasonId',
              'teamId',
              'playerId',
              'playerName',
              'playerLogo',
              'position',
              'shirtNumber',
              'active',
            ]
            let thisSeasonArrKey = []
            const thisSeason = res.data.thisSeason
            if (thisSeason) {
              thisSeason.columns.forEach((itemKey) => {
                if (!thisSeasonExpKey.includes(itemKey.colKey)) {
                  thisSeasonArrKey.push(itemKey)
                }
              })
              const thisSeasonArr = thisSeasonArrKey.map((item) => {
                item.val = thisSeason.data[item.colKey]
                return item
              })
              console.debug(
                'thisSeasonArrKey:',
                thisSeasonArrKey,
                thisSeasonArr
              )
              this.thisSeason = {
                title: '本届数据',
                shirtNumber: thisSeason.data.shirtNumber,
                position: thisSeason.data.position,
                active: thisSeason.data.active,
                arr: thisSeasonArr,
              }
            }

            const thisCmp = res.data.thisCmp
            if (thisCmp) {
              const thisCmpArr = thisCmp.columns.map((item) => {
                console.debug(item.colKey, thisCmp.data[item.colKey])
                item.val = thisCmp.data[item.colKey]
                return item
              })

              this.thisCmp = {
                title: '世界杯',
                arr: thisCmpArr,
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_teamDetail {
  padding-top: 19.86vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 2.083vw 9.722vw 0 9.722vw;
    width: 100%;
    height: 14.16vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
    .player_image {
      width: 12.222vw;
      height: 15.625vw;
      border: 0.694vw solid var(--mixtmt_mainColor4);
      border-radius: 0.694vw;
      background-image: var(--mixtmt_default_playerLogo);
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center bottom;
      overflow: hidden;
      &.isLogo {
        background-image: none;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .player_baseInfor {
      padding: 0 1.388vw;
      width: calc(100% - 12.222vw);
      .player_name {
        padding-top: 1.736vw;
        font-size: 2.083vw;
        width: 100%;
        font-weight: bold;
        color: var(--mixtmt_whiteColor);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .team_infor {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 1.736vw;
        width: 100%;
        height: auto;
        .teamLogo {
          width: 2.5vw;
          height: 2.5vw;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamName {
          padding: 0 0.694vw;
          width: calc(100% - 2.5vw);
          font-size: 1.25vw;
          color: var(--mixtmt_whiteColor);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .player_info {
        display: flex;
        margin-top: 0.278vw;
        font-size: 0.972vw;
        line-height: 1.25vw;
        align-items: center;
        gap: 0.694vw;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        & > div:not(:last-child) {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          &::after {
          content: '';
            display: block;
            width: 0.12vw;
            height: 0.972vw;
            background-color: var(--mixtmt_whiteColor);
            margin-left: 0.694vw;
          }
        }
        & > div:last-child {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .playerDetail_main {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    .left_area {
      width: 20.83vw;
      height: auto;
      color: var(--mixtmt_subColor_main);
      .matchData {
        width: 100%;
        height: auto;
        margin-bottom: 2.083vw;
        background: linear-gradient(
          135deg,
          var(--mixtmt_mainColor5) 0%,
          var(--mixtmt_mainColor) 100%
        );
        /* background-color: var(--mixtmt_mainColor5); */
        border-radius: 0.556vw;
        .item_title {
          display: block;
          padding: 1.11vw;
          .itemTitle_main {
            display: block;
            font-size: 1.25vw;
            line-height: 1.8vw;
            font-weight: bold;
            text-align: center;
          }
          .itemTitle_desRow {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            padding-top: 0.972vw;
            width: 100%;
            height: 2.36vw;
            .row_no {
              width: 3.472vw;
              text-align: left;
              font-size: 0.972vw;
            }
            .row_pos {
              flex: 1;
              text-align: left;
              font-size: 0.972vw;
            }
            .row_act {
              flex: 1;
              text-align: right;

              span {
                display: inline-block;
                font-size: 0.972vw;
                border: 1px solid var(--mixtmt_whiteColor);
                padding: 0.278vw;
              }
            }
          }
        }
        .item_row {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 3.194vw;
          padding: 0 1.11vw;
          border-top: 1px solid var(--mixtmt_greyColor9);
          .row_name {
            text-align: left;
          }
          .row_val {
            text-align: right;
          }
        }
      }
    }
    .right_area {
      width: calc(100% - 20.83vw);
      padding: 0 0 2.083vw 1.388vw;
      height: auto;
      .group_data {
        margin-bottom: 1.388vw;
        border: 1px solid var(--mixtmt_greyColor7);
        border-radius: 0.556vw;
        padding: 1.388vw;
        .groupData_title {
          display: block;
          padding-bottom: 2.083vw;
          font-size: 1.25vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
        .groupData_row {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          height: auto;
          .itemOther_targetList {
            width: 55%;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            .targetList_item {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: column;
              width: calc(100% / 3);
              height: 7.22vw;
              padding-right: 0.972vw;
              .targetItem_val {
                font-size: 1.8vw;
                line-height: 2.22vw;
                color: var(--mixtmt_greyColor3);
                font-weight: bold;
              }
              .targetItem_tip {
                font-size: 1.11vw;
                color: var(--mixtmt_greyColor2);
                word-break: break-word;
              }
            }
          }
        }
      }
    }
  }
}
</style>
